var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bodybg" },
    [
      _c("div", { staticClass: "wrap" }, [
        _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "main" },
            [
              _c("Header"),
              _vm._v(" "),
              _vm._t("banner"),
              _vm._v(" "),
              _c("div", { staticClass: "main_list" }, [
                _c(
                  "div",
                  { staticClass: "main_box_left" },
                  [_vm._t("mainBox")],
                  2
                )
              ])
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("el-backtop"),
      _vm._v(" "),
      _c("Footer", {
        scopedSlots: _vm._u(
          [
            {
              key: "footerImage",
              fn: function() {
                return [_vm._t("footerImage")]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05cfdf6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05cfdf6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommonPage.vue
// module id = null
// module chunks = 